
import Header from "@/components/header/header.vue";
import { reactive, ref, inject } from "vue";
import { useRouter } from "vue-router";
import { Toast } from 'vant';
export default {
  components: {
    Header,
  },
  setup() {
    const router: any = useRouter();
    const $http: any = inject("$http");
    const userInfo: any = reactive(
      common.getStorage("user_info") ? common.getStorage("user_info") : {}
    );
    const amendClick = (val: String) => {
      router.push(val);
    };
    
    const fileList = ref([
        { url: userInfo.avatar_url},
    ]);

    const afterRead = async (file: any) => {
      // 此时可以自行将文件上传至服务器
         console.log('files',file);
         
		  let formData = new FormData();
          formData.append('file',file.file)        
      const res = await $http.portrait_editor(formData);
      console.log(res);

      file.status = "uploading";
      file.message = "uploading";
      if(res.code === 200){
           Toast('success')   
          file.status = ''
          common.setStorage("user_info",res.data)
      }else{
        file.status = "failed";
        file.message = "error";
      }
     
    };
    return {
      userInfo,
      amendClick,
      afterRead,
      fileList,
    };
  },
};
